import axios from "axios";
const config = {
  headers: {
    Accept: "application/json",
  },
};
const url = "https://ipinfo.io?token=dfd25b664a2884";

export const getIP = () => {
  return axios.get(url, config);
};
